import React, { useContext } from 'react';
import { AppContext } from './AppContext'; // Importiere den Context
import { Button } from 'react-bootstrap';  // Beispiel mit Bootstrap

const ScreenPage = () => {
  const { textOnScreen, setTextOnScreen } = useContext(AppContext); // Hole dir myVariable und setMyVariable aus dem Context

  // Beispiel: Update myVariable
  const handleChangeVariable = () => {
    setTextOnScreen('Neue Variable');  // Ändere den Wert der Variablen
  };

  return (
    <div>
      <h1>Main Page</h1>
      <p>Aktueller Wert der Variable: {textOnScreen}</p>
      <Button onClick={handleChangeVariable}>Variable ändern</Button>  {/* Button zum Ändern der Variable */}
    </div>
  );
};

export default ScreenPage;
